<template>
  <div>
    <el-row class="container" style="margin-top:15px;" :gutter="20">
      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="6">
        <!-- Header filtros-->
        <el-row style="margin-bottom:15px;">
          <el-col :span="16">
            <div class="title">{{ $t('NAVBAR_solicitudes') }}</div>
          </el-col>
          <el-col :span="8" class="btn-nuevo">
            <router-link :to="{ name: 'Nueva Solicitud'}">
              <el-button
                type="primary"
                icon="Plus"
                size="small"
                round
              >{{ $t('GENERAL_nuevo') }}</el-button>
            </router-link>
          </el-col>
        </el-row>

        <!-- Filtros -->
        <el-row>
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('GENERAL_Busqueda_Simple')" name="1">
              <div class="filters">
                <div class="filters_item">
                  <div class="label">{{ $t('SOLICITUDES_nro_solicitud') }}</div>
                  <el-input
                    :placeholder="$t('SOLICITUDES_nro_solicitud')"
                    size="small"
                    v-model="filtros.nro_solicitud"
                    @input="getSolicitudesDelayed"
                  />
                </div>

                <!-- Nuevo: Nro. Serie -->
                <div class="filters_item">
                  <div class="label">{{ $t('SOLICITUDES_ns') }}</div>
                  <el-input
                    :placeholder="$t('SOLICITUDES_ns')"
                    size="small"
                    v-model="filtros.ns"
                    @input="getSolicitudesDelayed"
                  />
                </div>

                <!-- Nuevo: Clave -->
                <div class="filters_item">
                  <div class="label">{{ $t('SOLICITUDES_clave') }}</div>
                  <el-input
                    :placeholder="$t('SOLICITUDES_clave')"
                    size="small"
                    v-model="filtros.clave"
                    @input="getSolicitudesDelayed"
                  />
                </div>
                <!-- Nuevo: Periodo -->
                <el-row>
                  <el-col :span="2">
                    <el-checkbox                                       
                      v-model="filtros.checkPeriodo"
                      size="medium"
                      @change="changeCheck('P')">
                    </el-checkbox>
                  </el-col>
                  <el-col :span="20" style="text-align:left !important;">
                    <el-dropdown trigger="click" @command="changePeriodo" >
                        <span
                          :class="{'el-dropdown-link': filtros.checkPeriodo, 'el-dropdown-link-active': !filtros.checkPeriodo}">
                          {{this.$t(filtros.periodo)}}
                          <el-icon><ArrowDown /></el-icon>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item
                              command="SOLICITUDES_ultimo_mes"
                              :disabled="filtros.checkRango">{{$t('SOLICITUDES_ultimo_mes')}}</el-dropdown-item>
                            <el-dropdown-item
                              command="SOLICITUDES_ultimos_3_meses"
                            :disabled="filtros.checkRango">{{$t('SOLICITUDES_ultimos_3_meses')}}</el-dropdown-item>
                            <el-dropdown-item
                              command="SOLICITUDES_ultimo_anio" :disabled="filtros.checkRango"
                            >{{$t('SOLICITUDES_ultimo_anio')}}</el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                  </el-col>
                </el-row>
                <!-- Nuevo: Rango -->
                <el-row>
                  <el-col :span="2">
                    <el-checkbox
                        v-model="filtros.checkRango"
                        size="medium"
                        @change="changeCheck('R')">              
                      </el-checkbox>
                  </el-col>
                  <el-col :span="20">
                    <div class="label">{{$t('GENERAL_desde')}}</div>
                      <el-date-picker
                        v-model="filtros.from"
                        type="date"
                        size="small"
                        format="DD/MM/YYYY"
                        suffix-icon="Calendar"
                        placeholder="dd/mm/aaaa"
                        @input="getSolicitudesDelayed"
                        @change="getSolicitudesDelayed"
                        :disabled="filtros.checkPeriodo"
                      />

                      <div class="label">{{$t('GENERAL_hasta')}}</div>
                      <el-date-picker
                        v-model="filtros.to"
                        type="date"
                        size="small"
                        format="DD/MM/YYYY"
                        suffix-icon="Calendar"
                        placeholder="dd/mm/aaaa"
                        @input="getSolicitudesDelayed"
                        @change="getSolicitudesDelayed"
                        :disabled="filtros.checkPeriodo"
                      />
                  </el-col>
                </el-row>
                <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de b�squeda -->
      <el-col class="container_col_2" :span="17">
        <!-- Header resultados de b�squeda -->
        <el-row style="margin-bottom:15px;">
          <el-col :xs="8" :sm="12" :md="10" :lg="16" :xl="16">
            <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>

          <el-col :xs="16" :sm="12" :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              :pager-count="5"
              @current-change="handlePageChange"
              hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>

        <!-- Solicitudes -->
        <el-row>
          <el-col :span="24">
            <div class="card_list">
              <div v-if="loading" v-loading.lock="loading" class="loader"></div>

              <div
                v-else-if="solicitudes !== undefined && solicitudes.length > 0"
                class="card_list_item"
                v-for="(solicitud, index) in solicitudes"
                :key="index"
              >
                <SolicitudCard
                  :solicitud="solicitud"
                  @editar="editSolicitud"
                  @borrar="onBorrarSolicitud"
                />
              </div>

              <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
            </div>
          </el-col>
        </el-row>

        <!-- Paginador abajo -->
        <el-row class="paginator_bottom">
          <el-col :xs="8" :sm="12" :md="10" :lg="16" :xl="16"></el-col>
          <el-col :xs="16" :sm="12" :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              :pager-count="5"
              @current-change="handlePageChange"
              hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- BORRAR SOLICITUD DE SERVICIO -->
    <AppDialog      
      :visible="id_solicitud_a_borrar !== undefined"
      :title="$t('SOLICITUDES_borrar_solicitud_titulo')"
      :message="borrar_solicitud_msg"
      :onClose="onCloseBorrarConfirmation"/>
  </div>
</template>

<script>
import SolicitudCard from "@/components/Cards/solicitudCard";
import { mostrarMensajeInternacionalizado } from "../MensajeInternacionalizado"
import { showSuccess } from "../Mensaje";
import { mapState } from "vuex";
import AppDialog from "../Dialog";

let defaultFiltros = {
  nro_solicitud:"",
  ns: "",
  clave: "",
  from: undefined,
  to: undefined,
  periodo: "SOLICITUDES_ultimo_mes",
  tipo_filtro: "SOLICITUDES_confirmado_periodo",
  checkPeriodo:true,
  checkRango:false
};

let defaultPaginador = {
  page: 1,
  pageSize: 12,
  nro_pages: 0
};

export default {
  name: "SolicitudesListado",
  components: { SolicitudCard, AppDialog },
  data() {
    return {
      solicitudes: undefined,
      filtros: { ...defaultFiltros },
      paginador: { ...defaultPaginador },
      loading: false,
      activeNames: ["1"],

      id_solicitud_a_borrar: undefined,
      borrar_solicitud_msg:'',
    };
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      ultimoFiltroAplicado: state => state.solicitudes.filtroSolicitudes
    })
  },
  methods: {
    changeCheck(check){
      if(check =='P'){
        this.filtros.checkRango = this.filtros.checkPeriodo == true? false : true;
        this.filtros.tipo_filtro = "SOLICITUDES_confirmado_periodo";
      }
      else{ 
        this.filtros.checkPeriodo =this.filtros.checkRango == true? false:true;
        this.filtros.tipo_filtro = "SOLICITUDES_confirmado_rango";
      }
    },
    changePeriodo(periodo) {
      this.filtros.periodo = periodo;
      this.filtros.to = new Date();
      this.filtros.from = new Date();
      this.getSolicitudes();
    },
    mapPeriodoToMeses() {
      switch (this.filtros.periodo) {
        case "SOLICITUDES_ultimo_mes":
          return -1;
        case "SOLICITUDES_ultimos_3_meses":
          return -3;
        case "SOLICITUDES_ultimo_anio":
          return -12;
        default:
          return 1;
      }
    },
    disabledDateFrom(time) {
      if (this.filtros.to !== "") return time.getTime() > this.filtros.to;
      else return false;
    },
    disabledDateTo(time) {
      if (this.filtros.from !== "") return time.getTime() < this.filtros.from;
      else return false;
    },
    handlePageChange(page) {
      this.paginador.page = page;
      this.getSolicitudes();
    },
    getSolicitudes() {
      // indico que se est�n buscando las solicitudes de servicio
      this.loading = true;

      // armo el payload
      let payload = {};
      payload.idUsuario = this.idUsuario;
      payload.page = this.paginador.page;
      payload.pageSize = this.paginador.pageSize;
      payload.nro_solicitud = this.filtros.nro_solicitud;
      payload.ns = this.filtros.ns;
      payload.clave = this.filtros.clave;

      if (
        this.filtros.tipo_filtro !== "SOLICITUDES_confirmado_periodo"
      ) {
        payload.fechaDesde = this.filtros.from;
        payload.fechaHasta = this.filtros.to;
      } else payload.mesesADesfazar = this.mapPeriodoToMeses();

      // busco las solicitudes
      this.$store
        .dispatch("solicitudes/getSolicitudes", payload)
        .then(data => {
          // cargo la cantidad de p�ginas
          this.paginador.nro_pages = data.Datos ? data.Datos.TotalPaginas : 0;

          // agrego la propiedad 'seleccionado' a los items de solicitud
          let solicitudes = data.Datos ? data.Datos.Solicitudes : [];
          solicitudes.map(sol => (sol.seleccionado = false));
          this.solicitudes = solicitudes;
        })
        .finally(() => (this.loading = false));
    },
    getSolicitudesDelayed() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.paginador = { ...defaultPaginador };
        this.getSolicitudes();
      }, 1000);
    },
    cleanFilters() {
      // limpio los filtros
      this.filtros = { ...defaultFiltros };
      this.paginador = { ...defaultPaginador };

      // busco las solicitudes
      this.getSolicitudes();
    },
    changeTipoServicio(value) {
      this.filtros.tipo_servicio = value;
      this.getSolicitudes();
    },
    editSolicitud(id_solicitud) {
      this.$router.push({ path: `/solicitudes/edicion/${id_solicitud}` });
    },
    setFechas() {
      this.filtros.to = new Date();
      this.filtros.from = new Date();
    },
    onBorrarSolicitud(solicitud) 
    {
      // armo el mensaje a mostrar
      let mensaje = this.$t("SOLICITUDES_borrar_solicitud_mensaje");
      mensaje = mensaje.replace("[nro_solicitud]", solicitud.NumeroSolicitud);
      this.borrar_solicitud_msg = mensaje;

      // guardo la solicitud a borrar
      this.id_solicitud_a_borrar = solicitud.IdSolicitud;
    },
    onCloseBorrarConfirmation(confirm) {
      // si confirm� el di�logo, borro la solicitud
      if (confirm) {
        this.borrarSolicitud(this.id_solicitud_a_borrar);
      }

      // limpio los valores del di�logo
      this.id_solicitud_a_borrar = undefined;
      this.anular_asociacion_msg = "";
    },
    borrarSolicitud(id_solicitud) {
      this.$store.dispatch("solicitudes/borrarSolicitud", { solicitudId: id_solicitud })
      .then(result => {
        if (result.CodigoResultado != 0) 
        {
          mostrarMensajeInternacionalizado(result.CodigoResultado, result.DescripcionResultado);
        } 
        else 
        {
          showSuccess(this.$t("GENERAL_success"));
          this.getSolicitudes();
        }
      });
    }
  },
  mounted() {
    //Scroll para Android
    document.body.scrollTop = 0;
    //Scroll para IOS
    document.documentElement.scrollTop = 0;
    // verifico si se deben mantener los �ltimos filtros aplicados
    if (this.$route.params.keepFilter === true) {
      this.filtros = { ...this.ultimoFiltroAplicado };
      this.filtros.periodo = "SOLICITUDES_ultimo_mes";
      this.filtros.tipo_filtro = "SOLICITUDES_confirmado_periodo";
      this.filtros.ns = this.$route.params.ns !==undefined? this.$route.params.ns : this.ultimoFiltroAplicado.ns;
    }
    
    // busco las solicitudes
    this.getSolicitudes();
  },
};
</script>

<style scoped>
.btn-nuevo {
  padding-right: 0%;
  text-align: right;
}
.container {
  display: flex;
  min-height: 500px !important;
  width: 100% !important;
}
.pagination_container {
  text-align: right;
  padding-right: 0px;
}

.container_col_1 .el-collapse,
.container_col_1 .el-collapse.el-collapse-icon-position-right {
  width: 100%;
}

.paginator_bottom {
  margin-top: 10px;
  text-align: right;
}
.el-radio__label{
  max-height: 28px !important;    
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .container_col_2 {
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-top: 20px;
  }
}
.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}
.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}
.username {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}
.ns_dominio {
  font-size: 12px;
  font-weight: 100;
  color: #878585;
  text-align: left;
}
.tag {
  float: right;
  margin-top: 7px;
}
.info {
  margin-top: 20px;
}
.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  margin-bottom: 5px;
  font-weight: bold;
}
.switch {
  margin-left: 10px;
  margin-bottom: 2px;
}
.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}
.el-card__body {
  padding: 20px 40px;
}
.triangleRight {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
  position: absolute;
  left: 18px;
  top: 28px;
  cursor: pointer;
}
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
  position: absolute;
  left: 18px;
  top: 28px;
  cursor: pointer;
}
.cardBody {
  padding-left: 25px;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.soonToExpire {
  font-size: 14px;
  color: #2e2e2e;
  font-weight: bold;
  text-align: left;
  margin-top: 40px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-weight: bold !important;
}

.el-icon-arrow-down {
  font-size: 12px;
}
.loader {
  margin-top: 25%;
  color: #999;
}
.el-select {
  width: 100%;
}
</style>
